"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var domain = require("domain");
var domainContext = require("domain-context");
// Not using symbols, because this may need to run in a version of Node.js that doesn't support them
var domainTasksStateKey = '__DOMAIN_TASKS';
var domainTaskBaseUrlStateKey = '__DOMAIN_TASK_INTERNAL_FETCH_BASEURL__DO_NOT_REFERENCE_THIS__';
var noDomainBaseUrl;
function addTask(task) {
  if (task && domain.active) {
    var state_1 = domainContext.get(domainTasksStateKey);
    if (state_1) {
      state_1.numRemainingTasks++;
      task.then(function () {
        // The application may have other listeners chained to this promise *after*
        // this listener, which may in turn register further tasks. Since we don't 
        // want the combined task to complete until all the handlers for child tasks
        // have finished, delay the response to give time for more tasks to be added
        // synchronously.
        setTimeout(function () {
          state_1.numRemainingTasks--;
          if (state_1.numRemainingTasks === 0 && !state_1.hasIssuedSuccessCallback) {
            state_1.hasIssuedSuccessCallback = true;
            setTimeout(function () {
              state_1.completionCallback( /* error */null);
            }, 0);
          }
        }, 0);
      }, function (error) {
        state_1.completionCallback(error);
      });
    }
  }
}
exports.addTask = addTask;
function run(codeToRun, completionCallback) {
  var synchronousResult;
  domainContext.runInNewDomain(function () {
    var state = {
      numRemainingTasks: 0,
      hasIssuedSuccessCallback: false,
      completionCallback: domain.active.bind(completionCallback)
    };
    try {
      domainContext.set(domainTasksStateKey, state);
      synchronousResult = codeToRun();
      // If no tasks were registered synchronously, then we're done already
      if (state.numRemainingTasks === 0 && !state.hasIssuedSuccessCallback) {
        state.hasIssuedSuccessCallback = true;
        setTimeout(function () {
          state.completionCallback( /* error */null);
        }, 0);
      }
    } catch (ex) {
      state.completionCallback(ex);
    }
  });
  return synchronousResult;
}
exports.run = run;
function baseUrl(url) {
  if (url) {
    if (domain.active) {
      // There's an active domain (e.g., in Node.js), so associate the base URL with it
      domainContext.set(domainTaskBaseUrlStateKey, url);
    } else {
      // There's no active domain (e.g., in browser), so there's just one shared base URL
      noDomainBaseUrl = url;
    }
  }
  return domain.active ? domainContext.get(domainTaskBaseUrlStateKey) : noDomainBaseUrl;
}
exports.baseUrl = baseUrl;